// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import About from "./components/About";
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap/dist/js/bootstrap.min";

// or using CJS
// const VueMasonryPlugin = require('vue-masonry').VueMasonryPlugin


Vue.config.productionTip = false;

const HomePage = {
  template: '<App/>',
  components: { App }
};
const AboutPage = {
  template: '<About/>',
  components: { About }
};

const routes = {
  '/': HomePage,
  '/about': AboutPage
};

new Vue({
  el: '#app',
  data: {
    currentRoute: window.location.pathname
  },
  computed: {
    ViewComponent () {
      console.log("Current Routes is " + this.currentRoute);
      return routes[this.currentRoute] || AboutPage
    }
  },
  render (h) { return h(this.ViewComponent) },
});



// WEBPACK FOOTER //
// ./src/main.js